
'use strict';


const setupSingleForm = (id: string) => {
    const inputField = document.getElementById(id) as HTMLInputElement;

    if(inputField) {
        let initialValue = inputField.value
        const saveButton = document.getElementById(`edit_${id}_button`)
        if(!saveButton) {
            return
        }
        const form = document.getElementById(`edit_${id}`) as HTMLFormElement

        const eventType = inputField.tagName.toLowerCase() === 'select' ? 'change' : 'keyup'

        inputField.addEventListener(eventType, () => {
            if (inputField.value === initialValue) {
                saveButton.setAttribute('disabled', '1')
            } else {
                saveButton.removeAttribute('disabled')
            }
        })
        saveButton.addEventListener('click', (event) => {
            event.preventDefault()
            const data = new FormData(form)
            fetch(form.action, {
                method: 'POST',
                body: data,
            }).then((response) => {
                if(response.status === 200) {
                    saveButton.setAttribute('disabled', '1')

                    const target = event.target as HTMLElement
                    if(target.id === 'edit_default_language_button') { // reload the page

                        const path = document.location.pathname.split('/')
                        path[1] = inputField.value


                        document.location.pathname = path.join('/')
                    }
                    initialValue = data.get(id)!.toString()

                } else {
                    inputField.value = initialValue
                }
            })
        })
    }
}
export function setupSettingsForms() {
    if (document.location.href.indexOf('/settings') > 0){
        setupSingleForm('fullname')
        setupSingleForm('username')
        // setupSingleForm('discoverable')
        setupSingleForm('default_language')
        setupSingleForm('default_timezone')
        setupSingleForm('email_subject')
        setupSingleForm('email_body')
    }
    if (document.location.href.indexOf('/upgrade_subscription') > 0){
        setupSingleForm('webref')
    }
}